import { Injectable } from '@angular/core';
import { IAuthSession } from '../interfaces';

const SESSION_KEY = 'session';

@Injectable({ providedIn: 'root' })
export class AuthStore {
  public hasSession(): boolean {
    return localStorage.getItem(SESSION_KEY) !== null;
  }

  public storeSession(session: IAuthSession): void {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }

  public removeSession(): void {
    localStorage.removeItem(SESSION_KEY);
  }

  public getSession(): IAuthSession {
    const session = localStorage.getItem(SESSION_KEY);

    if (session === null) {
      throw new Error('Session not found');
    }

    return <IAuthSession>JSON.parse(session);
  }
}
